export const SITE = "diamondbacks";
export const HOME_TEAMS = ["diamondbacks"];
export const MAIN_COLOR = "#9561a9";
export const BACKUP_LOGO_URL = "/img/logo.png";

export const getTeamLinks = (rosterPagePath) => [
  {
    label: "Roster & Coaching Staff",
    url: rosterPagePath,
  },
  {
    label: "Player Application",
    url: "/player-application",
  },
  {
    label: "Statistics",
    url: "/stats",
  },
];

export const facilityLinks = [
  {
    label: "Glen Hansen Field",
    url: "/facilities/glen-hansen-field",
  },
  {
    label: "Webber Academy",
    url: "/facilities/webber-academy",
  },
];

export const aboutLinks = [
  {
    label: "News",
    url: "/news",
  },
  {
    label: "Sponsors",
    url: "/sponsors",
  },
  {
    label: "Contact",
    url: "/contact",
  },
  {
    label: "Fan Shop",
    url: "/fan-shop",
  },
];

export const socialMediaData = {
  instagram: "https://www.instagram.com/dingerbatdbacks/",
  twitter: "https://x.com/DingerBatDBacks",
  facebook: undefined,
  tiktok: undefined,
  youtube: undefined,
};

export const timelineAccount = "DingerBatDBacks";
